import LocaleSelector, {
  LocaleCode,
} from 'ca-communications-page/KioskModeSettings/components/LocaleSelector/LocaleSelector';
import React, { useEffect, useState } from 'react';

type LocaleProps = {
  name: string;
  code: string;
};

type Props = {
  splashScreenLocaleSelect?: boolean;
  supportedLocales: LocaleProps[];
  defaultLocale: LocaleProps;
};

const SelectLanguageLocale = ({
  supportedLocales,
  defaultLocale,
  splashScreenLocaleSelect,
}: Props) => {
  const searchParams = new URLSearchParams(window.location.search);

  useEffect(() => {
    if (selectedLocale !== defaultLocale.code) {
      if (searchParams.get('locale')) {
        searchParams.set('locale', selectedLocale);
        window.location.search = searchParams.toString();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const [selectedLocale, setSelectedLocale] = useState<LocaleCode>(
    defaultLocale.code as LocaleCode
  );

  const itemList =
    supportedLocales.length > 1
      ? supportedLocales.map((item) => item.code)
      : [];

  return (
    <LocaleSelector
      classNameOverride={
        splashScreenLocaleSelect
          ? 'splash-screen__locale-select--responses--legacy'
          : ''
      }
      supportedLocales={itemList as LocaleCode[]}
      selectedLocale={selectedLocale}
      setSelectedLocale={setSelectedLocale}
      fullWidth={true}
    />
  );
};

export default SelectLanguageLocale;
